import { render, staticRenderFns } from "./SupportCaseTable.vue?vue&type=template&id=5e74d62a"
import script from "./SupportCaseTable.vue?vue&type=script&lang=js"
export * from "./SupportCaseTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports